import React from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import { Link } from "react-router-dom";
const GameApk = (props) => {
    const otherMedia = useSelector((state) => state.othermediaInformationListR?.data);
    const saveApkLogo = (index) => {
        localStorage.setItem('app_icon',  index);
    }
    return (
        <div className='popup-box game-apk-popup'>
            <h4 className="title">{props.t('game_apk')}</h4>
            <div className='menu-apk-mobile'>
                <div className='item'>
                    <div className='sidebar-menu-grid'>
                        <ul className='sidebarApkGrid'>
                            {otherMedia?.['app_logo']?.map((v, i) => (
                            <li className="menu-grid-a border-sidebar_menu text-sidebar_menu">
                                    <div key={i}>
                                        <a onClick={() => saveApkLogo(i+1)}>
                                            <img
                                                src={v?.path}
                                                width={v?.width}
                                                height={v?.height}
                                                alt={v?.alt || "no_image"}
                                            />
                                        </a>
                                    </div>
                            </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
};

GameApk.propTypes = {
    preGlobalFilteredRows: PropTypes.any,
};

export default withTranslation()(GameApk);
